// eslint-disable-next-line import/no-anonymous-default-export
export default {
  title: 'Haritalar',
  subtitle: 'Müşteri ve şirket konumlarını haritada görüntüleyin',
  allLocations: 'Tüm Konumlar',
  customers: 'Müşteriler',
  companies: 'Şirketler',
  noLocations: 'Konum bilgisi bulunamadı',
  noLocationsDesc: 'Haritada gösterilecek konum verisi yok.',
  fetchError: 'Konum verileri alınamadı',
  loginRequired: 'Bu sayfayı görüntülemek için giriş yapın',
  connectionError: 'Sunucuya bağlanılamadı',
  standardMap: 'Standart Harita',
  standardMapDesc: 'İşaretçili standart harita görünümü',
  clusteredMap: 'Kümelenmiş Harita',
  clusteredMapDesc: 'Kümelenmiş işaretçilerle harita',
  heatmapMap: 'Isı Haritası',
  heatmapMapDesc: 'Sıcaklık yoğunluk görselleştirmesi',
  territoryMap: 'Bölge Haritası',
  territoryMapDesc: 'Bölge sınırları',
  networkMap: 'Ağ Haritası',
  networkMapDesc: 'Ağ bağlantıları',
  turkeyMap: 'Türkiye Haritası',
  turkeyMapDesc: 'Türkiye il haritası',
  defaultView: 'Varsayılan Görünüm',
  clearProvinceSelection: 'İl Seçimini Temizle',
  companyLocationsShown: 'şirket gösteriliyor',
  mapLegend: 'Kırmızı: Şirket var, Gri: Şirket yok',
  selectedProvince: 'Seçili',
  provinceDistribution: 'İl Dağılımı',
  provinceDistributionDesc: 'İllere göre şirketler',
  noCompaniesWithProvince: 'İl bilgisi olan şirket yok',
  selectProvinceWhenAdding: 'Şirket eklerken il seçin',
  companyLocations: 'Şirket Konumları',
  noCompaniesWithLocation: 'Konum Bilgisi Olan Şirket Yok',
  noCompaniesWithLocationDesc: 'Şirketlerin konum bilgisi yok. Şirketleri haritada görmek için konum bilgisi ekleyin.',
  addLocationToCompanies: 'Şirketlere Konum Ekle',
  selected: 'Seçili'
};
